import React from 'react'

// Components
import Header from '../components/Header'
import Footer from '../components/Footer'

const midiaPage = () =>
  <div>
    <Header name="site-header" style={{paddingBottom: '150px', marginBottom: '-130px'}}>
      <div className="container">
        <div className="grid-center">
           <div className="col-8_md-10 grid-column content center">
             <h1>
               Conheça nossos parceiros
             </h1>
             <p>O Talkative conta com um excelente time de colaboradores e parceiros para garantir a melhor ferramenta para a sua empresa ou organização.</p>
           </div>
        </div>
      </div>
    </Header>
    <section className="midia-section" style={{marginBottom: '100px'}}>
      <div className="container">
        <div className="grid-noGutter-equalHeight-center box-list">
          <div className="col-4_xs-12 box">
            <div>
              <img src={require('../sass/images/partner-vimeo.png')} alt=""/>
            </div>
          </div>

          <div className="col-4_xs-12 box">
            <div>
              <img src={require('../sass/images/partner-soundcloud.png')} alt=""/>
            </div>
          </div>

          <div className="col-4_xs-12 box">
            <div>
              <img src={require('../sass/images/partner-linkedin.png')} alt=""/>
            </div>
          </div>


          <div className="col-4_xs-12 box">
            <div>
              <img src={require('../sass/images/partner-ball.png')} alt=""/>
            </div>
          </div>

          <div className="col-4_xs-12 box">
            <div>
              <img src={require('../sass/images/partner-twitter.png')} alt=""/>
            </div>
          </div>

          <div className="col-4_xs-12 box">
            <div>
              <img src={require('../sass/images/partner-globo.png')} alt=""/>
            </div>
          </div>


          <div className="col-4_xs-12 box">
            <div>
              <img src={require('../sass/images/partner-facebook.png')} alt=""/>
            </div>
          </div>

          <div className="col-4_xs-12 box">
            <div>
              <img src={require('../sass/images/partner-google.png')} alt=""/>
            </div>
          </div>

          <div className="col-4_xs-12 box">
            <div>
              <img src={require('../sass/images/partner-apple.png')} alt=""/>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>

export default midiaPage



// WEBPACK FOOTER //
// ./src/pages/parceiros.js